import {IContasContabeisFiltroDto} from "@models/contaContabil/createContaContabilDto.ts";
import {Button, FormControlLabel, Grid, Switch, TextField} from "@mui/material";
import {useState} from "react";
import {DefaultDatePicker} from "@shared/custom/DefaultDatePicker.tsx";
import {CheckOutlined} from "@mui/icons-material";
import {fullHeight} from "@models/helpers.ts";

interface CcFiltersPage {
    filtros?: IContasContabeisFiltroDto
    setFiltros?: (v: IContasContabeisFiltroDto) => void
    onApply?: () => void
}

export function CcFiltersPage(props: CcFiltersPage) {
    const {filtros, setFiltros, onApply} = props

    // Create a local state from the original filters
    const [value, setValue] = useState<IContasContabeisFiltroDto>({...filtros || {}});

    // Handle apply button click
    const handleAplicar = () => {
        if (setFiltros != null)
            setFiltros(value);

        if (onApply != null) onApply();
    }

    return (
        <Grid container spacing={2}>
            <Grid container size={12} justifyContent={'space-between'}>
                <Grid/>
                <Grid>
                    <Button
                        fullWidth
                        onClick={handleAplicar}
                        disabled={JSON.stringify(value) === JSON.stringify(filtros)}
                        color={'success'}
                        sx={{...fullHeight}}
                        endIcon={<CheckOutlined/>}
                    >
                        Aplicar
                    </Button>
                </Grid>
            </Grid>

            {/* Search field */}
            <Grid size={12}>
                <TextField
                    fullWidth
                    label={'Pesquisar'}
                    value={value.search || ''}
                    onChange={(e) => setValue({...value, search: e.target.value})}
                />
            </Grid>

            {/* Date fields */}
            <Grid size={{
                xs: 12,
                md: 6
            }}>
                <DefaultDatePicker
                    label={'Data de Criação Inicial'}
                    value={value.dataCriacaoInicial || null}
                    catchValue={(date) => setValue({...value, dataCriacaoInicial: date})}
                />
            </Grid>
            <Grid size={{
                xs: 12,
                md: 6
            }}>
                <DefaultDatePicker
                    label={'Data de Criação Final'}
                    value={value.dataCriacaoFinal || null}
                    catchValue={(date) => setValue({...value, dataCriacaoFinal: date})}
                />
            </Grid>

            {/*<Grid size={{
                xs: 12,
                md: 6
            }}>
                <DefaultDatePicker 
                    label={'Data de Solicitação Inicial'}
                    value={value.dataSolicitacaoInicial || null}
                    catchValue={(date) => setValue({...value, dataSolicitacaoInicial: date})}
                />
            </Grid>
            <Grid size={{
                xs: 12,
                md: 6
            }}>
                <DefaultDatePicker 
                    label={'Data de Solicitação Final'}
                    value={value.dataSolicitacaoFinal || null}
                    catchValue={(date) => setValue({...value, dataSolicitacaoFinal: date})}
                />
            </Grid>*/}

            {/* Conta Contábil selection
            <Grid size={12}>
                <ContaContabilPesquisa 
                    overrides={{label: 'Conta Contábil'}}
                    onSelect={(conta) => {
                        if (conta) {
                            setValue({
                                ...value, 
                                idContaContabil: [...(value.idContaContabil || []), conta.id]
                            });
                        }
                    }}
                />
            </Grid>
            
             Conta Contábil Pai selection
            <Grid size={12}>
                <ContaContabilPesquisa 
                    overrides={{label: 'Conta Contábil Pai'}}
                    onSelect={(conta) => {
                        if (conta) {
                            setValue({
                                ...value, 
                                idContaContabilPai: [...(value.idContaContabilPai || []), conta.id]
                            });
                        }
                    }}
                />
            </Grid>
            
             Recurso selection
            <Grid size={12}>
                <RecursoPesquisa 
                    overrides={{label: 'Recurso'}}
                    onSelect={(recurso) => {
                        if (recurso) {
                            setValue({
                                ...value, 
                                idRecurso: [...(value.idRecurso || []), recurso.id]
                            });
                        }
                    }}
                />
            </Grid>*/}

            {/* Status Ativo switch */}
            <Grid size={12}>
                <FormControlLabel
                    control={
                        <Switch
                            checked={value.statusAtivo || false}
                            onChange={(e) => setValue({...value, statusAtivo: e.target.checked})}
                        />
                    }
                    label={'Ativo'}
                />
            </Grid>
        </Grid>
    )
}